import { Upload, message } from 'antd'
import { DownloadOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { Button, Typography } from 'antd'
import { t } from 'i18next'
import { InfoModal } from './common'
import { useState } from 'react'

const { Title, Paragraph } = Typography
const { Dragger } = Upload

const ACCEPT_FILE_TYPES = [
  '.pdf',
  '.doc',
  '.docx',
  '.odt',
  '.rtf',
  '.pages',
  '.ppt',
  '.pptx',
  '.key',
  '.zip',
  'application/zip',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
]

const Uploader = ({ onUpload }) => {
  const [fileTypeError, setFileTypeError] = useState('')
  const props = {
    name: 'file',
    accept: ACCEPT_FILE_TYPES.join(','),
    maxCount: 1,

    customRequest(param) {
      if (isValidFileType(param.file)) {
        setFileTypeError('')
        onUpload(param)
      } else {
        setFileTypeError('file-type-error')
      }
    },
    onChange(info) {
      setFileTypeError('')
      const { status, file } = info
      if (status !== 'uploading') {
        console.log(file, info.fileList)
      }
      if (status === 'done') {
        message.success(`${file.name} file uploaded successfully.`)
      } else if (status === 'error') {
        message.error(`${file.name} file upload failed.`)
      }
    },
    onDrop(e) {
      if (e.dataTransfer.files.length > 1) {
        message.warning('Please upload 1 file only')
        setFileTypeError('file-type-error')
      }
      if (!isValidFileType(e.dataTransfer.files[0])) {
        setFileTypeError('file-type-error')
      }
    },
  }

  return (
    <>
      <InfoModal
        text={t('Upload.FileType')}
        title={t('Upload.FileType')}
        info={t('Upload.FileType.info')}
      />
      <Dragger {...props} className={fileTypeError}>
        {fileTypeError ? <ErrorView /> : <UploadView />}
      </Dragger>
    </>
  )

  function isValidFileType(file) {
    const fileExtension = '.' + file.name.split('.').pop()

    if (
      ACCEPT_FILE_TYPES.includes(fileExtension) ||
      ACCEPT_FILE_TYPES.includes(file.type)
    ) {
      return true
    }
    return false
  }
}
export default Uploader

const UploadView = () => {
  return (
    <>
      <DownloadOutlined className="show-on-desktop" />
      <Title level={3} className="show-on-desktop">
        {t('Upload.DragDrop')}
      </Title>
      <Button type="primary" className="show-on-desktop">
        {t('Upload.Select.button')}
      </Button>
      <Button type="primary" className="show-on-mobile">
        {t('Upload.Select.button.mobile')}
      </Button>
    </>
  )
}

const ErrorView = () => {
  return (
    <>
      <ExclamationCircleOutlined
        className="ant-upload-drag-icon show-on-desktop"
        style={{ color: 'red' }}
      />
      <Title level={3} className="ant-upload-text show-on-desktop">
        {t('Upload.WrongFileFormat')}
      </Title>
      <br />
      <Paragraph>
        {t('Upload.PleaseUse')}
        <br />
        {t('Upload.FileFormats')}
      </Paragraph>
    </>
  )
}
